import Swiper, { Pagination, Manipulation } from "swiper";
import { addToGlobalThisRet } from "@plugins";

const upsell = document.querySelector(".js-upsell-slider-init");

function initUpsellSlider() {
    if (upsell) {
        const pagination = upsell.querySelector(".js-upsell-pagination");

        new Swiper(".js-upsell-slider-init > .swiper", {
            modules: [Pagination, Manipulation],
            slidesPerView: 1.75,
            spaceBetween: 8,
            pagination: {
                el: pagination,
                type: "progressbar",
            },
            breakpoints: {
                406: {
                    slidesPerView: 1.9,
                },
                567: {
                    slidesPerView: 3,
                },
            },
        });
    }
}

window.addEventListener("load", () => {
    if (window.mobileMedia) {
        initUpsellSlider();
    }
});

addToGlobalThisRet(initUpsellSlider, "initUpsellSlider");
